import { useHistory, useLocation } from "react-router-dom";
import { FlowAddPaymentMethod } from "../../../modules/Settings/components/payment/FlowAddPaymentMethod";
import { Layout } from "../../../shared/components/Layout";

const DEFAULT_RETURN_PATH = "/payment/history";

export const RouteAddPaymentMethod: React.FC = () => {
  const history = useHistory();
  const { search } = useLocation();
  // Honor a returnTo so callers (e.g. removing a card mid-invoice-payment) can
  // send the payer back where they were instead of dumping them into history.
  // Restricted to in-app paths to avoid open redirects. See PLA-2549.
  const returnToParam = new URLSearchParams(search).get("returnTo");
  const returnTo =
    returnToParam &&
    returnToParam.startsWith("/") &&
    !returnToParam.startsWith("//")
      ? returnToParam
      : DEFAULT_RETURN_PATH;

  return (
    <Layout
      title="Add payment method"
      onClose={() => {
        history.push(returnTo);
      }}
      showFooterAdditionalInfo
    >
      <FlowAddPaymentMethod
        basePath="/payment/add-payment-method"
        onBack={() => {
          history.push("/payment/manage-payment-method");
        }}
        onNext={() => {
          history.push(returnTo);
        }}
      />
    </Layout>
  );
};
